<script>
import VoxuyModal from "@/components/tools/modals/Voxuy.vue";
import get from "lodash/get";
import IntegrationList from "../IntegrationList.vue";
export default {
  extends: IntegrationList,
  components: {
    VoxuyModal
  },
  data() {
    return {
      integration: "voxuy",
      name: "Voxuy",
      modal: VoxuyModal,
      columns: [
        {
          name: "Produto",
          field: "events",
          transform: this.getProductName
        },
        {
          name: "Descrição",
          field: "description"
        },
        {
          name: "Eventos",
          field: "events",
          transform: v => v.map(this.getEventName),
          type: "popper"
        },
        {
          name: "Token",
          field: "token"
        },
        {
          name: "ID do plano",
          field: "plan_id"
        },
        {
          name: "URL",
          field: "url",
          type: "link",
          size: "0.7fr"
        },
        {
          name: "Status",
          field: "status",
          type: "tag",
          transform: this.formatStatus,
          color: this.formatStatusColor,
          size: "0.7fr"
        },
        {
          name: "",
          type: "menu",
          options: this.getActions
        }
      ]
    };
  },
  methods: {
    getProductName(events) {
      return get(
        this.products.find(p => p.id === get(events[0], "product_id")),
        "name",
        "-"
      );
    },
    getEventName(event) {
      return this.typeEvents.find(t => t.id === event.event)?.name || "-";
    },
    changeStatus(item) {
      let data = { ...item };
      data.status = !data.status;
      data.product_id = item.events[0].product_id;
      this.$store
        .dispatch("integration/putIntegration", data)
        .then(() => {
          this.$message.success("Status alterado com sucesso");
          this.refresh();
        })
        .catch(() => {
          this.$message.error("Erro ao alterar status");
        });
    }
  }
};
</script>
